import type { ReportingTargetFilterDefinition } from '../reporting-target-filter.types';
import { agreementsReportingTargetDefinition } from './agreements.definition';
import { materialSummaryReportingTargetDefinition } from './material-summary.definition';

/**
 * All registered reporting targets. To add one:
 * 1. Add `your-target.definition.ts` in this folder with a `ReportingTargetFilterDefinition`.
 * 2. Import it here and append to this array.
 * 3. Add a matching `<option value="...">` in `taskpane.html`. Optional `recordTypeFilter` on the definition drives the Record type row (no HTML change per target).
 * 4. Target-specific filters below the divider are rendered from the definition via `renderReportingTargetPanels`.
 * 5. Register a task-pane fetch handler in `report-fetch/report-fetch-registry.ts` that delegates to the feature
 *    (e.g. `agreements/report/run-agreements-report-to-worksheet.ts`, `material-summary/report/...`).
 */
export const allReportingTargetDefinitions: readonly ReportingTargetFilterDefinition[] = [
    agreementsReportingTargetDefinition,
    materialSummaryReportingTargetDefinition,
];
